<template>
  <div>
    <div class="l-container">
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  methods: {
    // getFamilies () {
    //   this.$store.dispatch('getFamilies')
    // },

    getAppointments () {
      this.$store.dispatch('getAppointmentsLimit0')
    },

    getUsers () {
      this.$store.dispatch('getUsers')
    },

    getOffices () {
      this.$store.dispatch('getOffices')
    },

    getCompanies () {
      this.$store.dispatch('getCompanies')
    },

    getPrefs () {
      this.$store.dispatch('getPrefs')
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      // vm.getFamilies()
      vm.getAppointments()
      vm.getUsers()
      vm.getOffices()
      vm.getCompanies()
      vm.getPrefs()
    })
  },
  mounted () {
  }
}
</script>



// WEBPACK FOOTER //
// Families.vue?669ecdb0